var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea"},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label)+" :")]):_vm._e(),_c('textarea',_vm._g(_vm._b({domProps:{"value":_vm.value}},'textarea',_vm.$attrs,false),_vm.listeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }